import React from "react";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import usePharmacyNetwork from "./hooks/usePharmacyNetwork";

const PharmacyNetwork = () => {
  const pharmacyNetworkData = usePharmacyNetwork();

  return (
    <div className="container container-fluid">
      <ButtonsSection
        ctaButtons={pharmacyNetworkData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {pharmacyNetworkData.screen_title} -{" "}
          <span className="heading-cod">
            {pharmacyNetworkData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={pharmacyNetworkData.formFields}
        dropdownValues={pharmacyNetworkData.dropdownValues}
        paramsData={pharmacyNetworkData.paramsData}
        updataParamData={pharmacyNetworkData.updateParamData}
      />
      <ButtonsSection ctaButtons={pharmacyNetworkData.ctaButtons} />
      <DisplayTable
        data={pharmacyNetworkData.data}
        parmKey={pharmacyNetworkData.parmKey}
        menuOptions={pharmacyNetworkData.menuOptions}
        tableHeaders={pharmacyNetworkData.columnDef}
        setRowData={pharmacyNetworkData.setRowData}
        selectedPriceSchedules={pharmacyNetworkData.selectedRows}
        setSelectedPriceSchedules={pharmacyNetworkData.setSelectedRows}
        hideMenu={true}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={pharmacyNetworkData.first}
          rows={pharmacyNetworkData.rows}
          totalRecords={pharmacyNetworkData.totalRecords}
          currentPage={pharmacyNetworkData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={pharmacyNetworkData.onPageChange}
        />
      </div>
      {pharmacyNetworkData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={pharmacyNetworkData.isConfirmationModalOpen}
          onRequestClose={pharmacyNetworkData.closeConfirmationModal}
          onBack={pharmacyNetworkData.closeConfirmationModal}
          onSave={pharmacyNetworkData.deletePharmacyNetwork}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={pharmacyNetworkData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default PharmacyNetwork;
